function IndexViewActions () {
  return null
}

IndexViewActions.propTypes = {
}

export default IndexViewActions
